import Vue from "vue";
import Vuex from "vuex";

import login from "./modules/Mixins/login";
import standardize from "./modules/Mixins/standardizers";
import carrierCost from "./modules/OTR/carrierCost";
import specialServiceModel from "./modules/OTR/specialServiceModel";
import coordinatesMap from "./modules/OTR/coordinatesMap";
import mode from "./modules/OTR/mode";
import usersManagement from "./modules/usersManagement/usersManagement";
import quotes from "./modules/Mixins/quotes/quotes";
import totals from "./modules/Mixins/totals";
import cannedResponses from "./modules/Mixins/cannedResponses";
import cannedResponsesModule from "@/store/modules/Mixins/cannedResponsesModule";
import drayageCannedResponsesTablesModule from "@/store/modules/Mixins/drayageCannedResponsesTablesModule";
import dedicatedTablesModule from "@/store/modules/Mixins/dedicatedTablesModule";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    statusColor: null,
    handlingUnitsHuCount: []
  },
  getters: {
    showCannedResponsesOTR(state) {
      return state.cannedResponsesOTR;
    },
    showCannedResponsesLTL(state) {
      return state.cannedResponsesLTL;
    },
    showStatusColor(state) {
      return state.statusColor;
    },
    showHandlingUnitsHuCount(state) {
      return state.handlingUnitsHuCount;
    }
  },
  mutations: {
    setStatusColor(state, newStatusColor) {
      state.statusColor = newStatusColor;
    },
    setHandlingUnitsHuCount(state, info) {
      state.handlingUnitsHuCount[info.trip] = info.handlingUnit;
    }
  },

  actions: {},

  modules: {
    login,
    quotes,
    totals,
    standardize,
    coordinatesMap,
    mode,
    carrierCost,
    specialServiceModel,
    usersManagement,
    cannedResponses,
    cannedResponsesModule,
    drayageCannedResponsesTablesModule,
    dedicatedTablesModule
  }
});
